module.exports = __webpack_public_path__ + "img/graph-text_1.637373d4.svg";